'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const cartData = [
{ id: 1, name: 'HP DeskJet 2331 All-in-One', category: 'Inkjet', price: 89, image: "https://img.rocket.new/generatedImages/rocket_gen_img_19a0292fc-1764765555385.png", qty: 1 }];


export default function CartPage() {
  const [items, setItems] = useState(cartData);

  const updateQty = (id: number, delta: number) => {
    setItems((prev) => prev.map((item) => item.id === id ? { ...item, qty: Math.max(1, item.qty + delta) } : item));
  };

  const removeItem = (id: number) => {
    setItems((prev) => prev.filter((item) => item.id !== id));
  };

  const subtotal = items.reduce((sum, item) => sum + item.price * item.qty, 0);
  const shipping = subtotal > 200 ? 0 : 9.99;
  const total = subtotal + shipping;

  return (
    <div>
      <Header />
      <div className="page-hero">
        <div className="page-hero-grid" />
        <div style={{ maxWidth: 1280, margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <h1 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: 'clamp(2rem, 4vw, 3rem)', color: '#fff' }}>Your Cart</h1>
          <p style={{ color: 'rgba(255,255,255,0.6)', marginTop: 8 }}>{items.length} item{items.length !== 1 ? 's' : ''} in your cart</p>
        </div>
      </div>

      <section style={{ padding: '48px 16px', background: '#f0f4ff' }}>
        <div style={{ maxWidth: 1280, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 32 }}>
          {/* Cart Items */}
          <div style={{ flex: 2 }}>
            {items.length === 0 ?
            <div style={{ background: '#fff', borderRadius: 20, padding: 48, textAlign: 'center', border: '1px solid #E2E8F4' }}>
                <div style={{ fontSize: 64, marginBottom: 16 }}>🛒</div>
                <h3 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: '1.5rem', color: '#1A2235', marginBottom: 12 }}>Your cart is empty</h3>
                <p style={{ color: '#6B7A99', marginBottom: 24 }}>Add some printers to get started!</p>
                <Link href="/shop" style={{ background: '#005CBB', color: '#fff', padding: '12px 32px', borderRadius: 10, fontWeight: 700, textDecoration: 'none', display: 'inline-block' }}>Shop Now</Link>
              </div> :

            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                {items.map((item) =>
              <div key={item.id} style={{ background: '#fff', borderRadius: 16, padding: 20, border: '1px solid #E2E8F4', display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap' }}>
                    <div style={{ background: '#f0f4ff', borderRadius: 12, padding: 12, width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      <img src={item.image} alt={item.name} style={{ width: 60, height: 60, objectFit: 'contain' }}
                  onError={(e) => {(e.target as HTMLImageElement).src = `https://via.placeholder.com/60x60/e8f1ff/0057b8?text=HP`;}} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 11, color: '#005CBB', fontWeight: 700, textTransform: 'uppercase', marginBottom: 4 }}>{item.category}</div>
                      <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: 15, color: '#1A2235', marginBottom: 8 }}>{item.name}</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, border: '1px solid #E2E8F4', borderRadius: 8, overflow: 'hidden' }}>
                          <button onClick={() => updateQty(item.id, -1)} style={{ background: 'none', border: 'none', padding: '6px 12px', cursor: 'pointer', fontSize: 16, color: '#374151' }}>-</button>
                          <span style={{ fontSize: 14, fontWeight: 600, padding: '0 4px' }}>{item.qty}</span>
                          <button onClick={() => updateQty(item.id, 1)} style={{ background: 'none', border: 'none', padding: '6px 12px', cursor: 'pointer', fontSize: 16, color: '#374151' }}>+</button>
                        </div>
                        <button onClick={() => removeItem(item.id)} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>Remove</button>
                      </div>
                    </div>
                    <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: 20, color: '#1A2235' }}>${(item.price * item.qty).toFixed(2)}</div>
                  </div>
              )}
              </div>
            }
          </div>

          {/* Order Summary */}
          {items.length > 0 &&
          <div style={{ background: '#fff', borderRadius: 20, padding: 32, border: '1px solid #E2E8F4', height: 'fit-content' }}>
              <h3 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: '1.3rem', color: '#1A2235', marginBottom: 24 }}>Order Summary</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 24 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', color: '#6B7A99', fontSize: 14 }}>
                  <span>Subtotal</span><span>${subtotal.toFixed(2)}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', color: '#6B7A99', fontSize: 14 }}>
                  <span>Shipping</span><span>{shipping === 0 ? 'FREE' : `$${shipping.toFixed(2)}`}</span>
                </div>
                {shipping > 0 && <div style={{ fontSize: 12, color: '#22c55e' }}>Free shipping on orders over $200!</div>}
                <div style={{ borderTop: '1px solid #E2E8F4', paddingTop: 12, display: 'flex', justifyContent: 'space-between', fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: 18, color: '#1A2235' }}>
                  <span>Total</span><span>${total.toFixed(2)}</span>
                </div>
              </div>
              <button style={{ width: '100%', background: '#005CBB', color: '#fff', border: 'none', borderRadius: 10, padding: '14px', fontWeight: 700, cursor: 'pointer', fontSize: 15, marginBottom: 12 }}
            onMouseEnter={(e) => e.currentTarget.style.background = '#003D7A'}
            onMouseLeave={(e) => e.currentTarget.style.background = '#005CBB'}>
                Proceed to Checkout
              </button>
              <Link href="/shop" style={{ display: 'block', textAlign: 'center', color: '#005CBB', fontSize: 14, fontWeight: 600, textDecoration: 'none' }}>Continue Shopping</Link>
            </div>
          }
        </div>
      </section>

      <Footer />
    </div>);

}